import React, { useState } from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import Permission from "Components/Common/Permission";
import PSEAAssessmentsImportModal from "./PSEAAssessmentsImportModal";

/**
 * Toolbar menu for the PSEA Assessments list. Holds only Import for now —
 * PSEA has no CSV export endpoint, unlike contracts and PVRs.
 */
const Import = ({ onImported }: { onImported?: () => void }) => {
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  return (
    <>
      <UncontrolledDropdown>
        <DropdownToggle
          tag="button"
          className="btn btn-light"
          id="dropdownMenuButton"
        >
          <i className="ri ri-more-fill"></i>
        </DropdownToggle>
        <DropdownMenu>
          <Permission resource="psea-assessment" action="import">
            <DropdownItem
              onClick={() => {
                setIsImportModalOpen(true);
              }}
            >
              <i className="ri ri-upload-2-line me-1"></i>
              Import
            </DropdownItem>
          </Permission>
        </DropdownMenu>
      </UncontrolledDropdown>

      <PSEAAssessmentsImportModal
        toggle={() => setIsImportModalOpen(!isImportModalOpen)}
        isOpen={isImportModalOpen}
        onImported={onImported}
      />
    </>
  );
};

export default Import;
